import { format } from 'date-fns-jalali';

export function GregorianToJalali(date: Date, formatString = 'yyyy-MM-dd') {
    return format(date, formatString);
}
